export const paginationConstants = {
  rowsPerPageOptions: [20, 50, 100],
  firstPage: 0,
  defaultPageSize: 20,
};
